import SignalBars from "./SignalBars";

// Format timestamp nicely
function formatTimestamp(ts) {
  if (!ts) return "—";
  const date = new Date(ts);
  return date.toLocaleString(); // e.g. "12/10/2025, 21:01:19"
}

export default function VehiclePopup({ vehicle }) {
  console.log(vehicle);
  return (
    <div className="vehicle-popup clean-popup">

      {/* Vehicle Title */}
      <h4 className="popup-title">
        {vehicle.name || `Vehicle ${vehicle.id}`}
      </h4>

      {/* Timestamp */}
      <div className="timestamp-line">
        <span className="timestamp-label">Last Update:</span>
        <span className="timestamp-value">
          {formatTimestamp(vehicle.timeStamp)}
        </span>
      </div>

      {/* Status Rows */}
      <div className="status-row">
        <div
          className={`status-icon ${
            vehicle.ignitionOn ? "status-on" : "status-off"
          }`}
        ></div>
        <span>Ignition: {vehicle.ignitionOn ? "On" : "Off"}</span>
      </div>

      <div className="status-row">
        <SignalBars level={parseInt(vehicle.GSMSignal || "0")} />
        <span>Signal: {vehicle.GSMSignal || "N/A"}</span>
      </div>

      {/* Core Stats */}
      <div className="popup-stats">
        <p>
          <b>Speed:</b> {vehicle.speed ?? 0} km/h<br />
          <b>Movement:</b> {vehicle.movement ? "Moving" : "Stationary"}<br />
        </p>
      </div>

      {/* Location */}
      <div className="location-block">
        <p>
          <b>Lat/Lon:</b> {vehicle.lat?.toFixed(5)}, {vehicle.lon?.toFixed(5)}
        </p>
      </div>
    </div>
  );
}
